module.exports = __webpack_public_path__ + "img/Logotyp_jihomoravsky_kraj_CMYK.f253e8a8.png";